import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

/* ============================================================
   PÚBLICAS
   ============================================================ */

export async function listarJovenes() {
  const res = await api.get("/young-players");
  return res.data; // { items, total }
}

export async function obtenerJoven(id) {
  const res = await api.get(`/young-players/${id}`);
  return res.data;
}

/* ============================================================
   ADMIN
   ============================================================ */

export async function listarJovenesAdmin() {
  const res = await apiAuth.get("/young-players/admin/all");
  return res.data;
}

export async function crearJoven(payload) {
  const res = await apiAuth.post("/young-players", payload);
  return res.data;
}

export async function editarJoven(id, payload) {
  const res = await apiAuth.put(`/young-players/${id}`, payload);
  return res.data;
}

export async function eliminarJoven(id) {
  const res = await apiAuth.delete(`/young-players/${id}`);
  return res.data;
}

/**
 * Sube la foto del joven (después de crearlo en el backend).
 */
export async function subirFotoJoven(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(`/young-players/${id}/photo`, formData);
  return res.data;
}